export enum PayoutOrderEvents {
  CLOSE_DIALOG = 'close-dialog',
}
